import { COLOR_NAME } from '@/constant/color';

angular.module('inspinia').directive('shiftColorPalette', () => {
  return {
    restrict: 'E',
    scope: {
      onClick: '&',
      ngModel: '=',
      type: '@',
    },
    templateUrl: `/manage/src/view/directive/base_color_palette.html?${new Date().getTime()}`,
    link: ($scope) => {
      $scope.switchDisplayPalette = 'hidePalette';
      $scope.type = 'pale';

      /**
       * カラーパレットで選択出来る色の一覧を取得
       */
      $scope.getColorTypes = () => {
        let colors = '';
        if ($scope.type === 'pale') {
          colors = [
            COLOR_NAME.PALE.SCARLET,
            COLOR_NAME.PALE.YELLOW,
            COLOR_NAME.PALE.GREEN,
            COLOR_NAME.PALE.LIGHT_BLUE,
            COLOR_NAME.PALE.BLUE_VIOLET,
            COLOR_NAME.PALE.MAGENTA,
            COLOR_NAME.PALE.CORAL,
            COLOR_NAME.PALE.GREEN_YELLOW,
            COLOR_NAME.PALE.TURQUOISE,
            COLOR_NAME.PALE.DODGER_BLUE,
            COLOR_NAME.PALE.INDIGO,
            COLOR_NAME.PALE.PINK,
            COLOR_NAME.PALE.ORANGE,
            COLOR_NAME.PALE.LIGHT_GREEN,
            COLOR_NAME.PALE.CYAN,
            COLOR_NAME.PALE.BLUE,
            COLOR_NAME.PALE.PURPLE,
            COLOR_NAME.PALE.RED,
            COLOR_NAME.PALE.GOLD,
            COLOR_NAME.PALE.SEA_GREEN,
            COLOR_NAME.PALE.SKY_BLUE,
            COLOR_NAME.PALE.NAVY,
            COLOR_NAME.PALE.VIOLET,
            COLOR_NAME.PALE.SALMON,
          ];
        } else if ($scope.type === 'strong') {
          colors = [
            COLOR_NAME.STRONG.FIREBRICK,
            COLOR_NAME.STRONG.CARROT_ORANGE,
            COLOR_NAME.STRONG.MALACHITE_GREEN,
            COLOR_NAME.STRONG.MARINE_BLUE,
            COLOR_NAME.STRONG.PURPLE,
            COLOR_NAME.STRONG.STEEL_GREY,
            COLOR_NAME.STRONG.STRAWBERRY,
            COLOR_NAME.STRONG.DEEP_ORANGE,
            COLOR_NAME.STRONG.GREEN,
            COLOR_NAME.STRONG.COBALT_BLUE,
            COLOR_NAME.STRONG.PANSY,
            COLOR_NAME.STRONG.SEPIA,
            COLOR_NAME.STRONG.ROSE,
            COLOR_NAME.STRONG.GOLDEN_YELLOW,
            COLOR_NAME.STRONG.EMERALD_GREEN,
            COLOR_NAME.STRONG.CERULEAN_BLUE,
            COLOR_NAME.STRONG.ORIENTAL_BLUE,
            COLOR_NAME.STRONG.BROWN,
            COLOR_NAME.STRONG.OLD_ROSE,
            COLOR_NAME.STRONG.YELLOW_OCHER,
            COLOR_NAME.STRONG.GRASS_GREEN,
            COLOR_NAME.STRONG.ROYAL_BLUE,
            COLOR_NAME.STRONG.SAXE_BLUE,
            COLOR_NAME.STRONG.MAROON,
          ];
        } else {
          throw new Error('type not found.');
        }
        return colors;
      };

      /**
       * カラーパレットの開閉
       */
      $scope.toggleColorPalette = () => {
        $scope.switchDisplayPalette = $scope.switchDisplayPalette === 'showPalette' ? 'hidePalette' : 'showPalette';
      };

      /**
       * カラーパレットの色の選択
       */
      $scope.onClickColorPalette = (selectedColorName) => {
        $scope.ngModel = selectedColorName;

        const setValue = () => $scope.onClick();
        setTimeout(setValue, 100);
      };
    },
  };
});
